export const BUSINESS_NAME = 'Telecare Australia Pty Ltd';
export const BUSINESS_ABN = 'ABN 37 632 722 911';
export const BUSINESS_DESCRIPTOR = 'Registered Australian telehealth provider';
export const CONTACT_PHONE = '03 9052 4872';
export const CONTACT_EMAIL = 'invoice@telecare.com.au';
export const PAYMENT_GATEWAY_NAME = 'Pin Payments';
export const SERVICE_DESCRIPTION = 'Specialist telehealth medical appointment';
export const APPOINTMENT_GUIDE_URL =
  'https://www.telecare.com.au/how-it-works/appointment-guide';
export const TENANT_TIMEZONE = 'Australia/Melbourne';
